import { getAuditActionMeta } from "../../utils";
import { INTENT_STYLES } from "./auditActionStyles";

export default function AuditActionBadge({ action }: { action: string }) {
  const { label, intent } = getAuditActionMeta(action);
  const { Icon, className } = INTENT_STYLES[intent];
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ring-1 ${className}`}
    >
      <Icon size={12} />
      {label}
    </span>
  );
}
